export const ACCESS_TYPE = {
  CONSOLE: 'CONSOLE',
  PROGRAMMATIC: 'PROGRAMMATIC',
}

export default ACCESS_TYPE
